namespace Areas.TimeEntry {
    "use strict";

    enum GridOperation { None, Insert, Update, Delete }

    let gridOperation: GridOperation = GridOperation.None;

    $(() => { 
        UpdateTotals(); 
    });

    export function UpdateTotals() {
        
        $(".week-totals").each(function (i) {
            var element = this;
            const employeeId = $("#EmployeeId").val();
            const usageDate = $(this).data("start-date");
            
            $.ajax({
                url: `/TimeEntry/TimeEntry/WeekTotals/${employeeId}/${usageDate}`,
                method: "GET",
                success: function (result) {
                    $(element).html("Non-Work: " + result.nonWorkHours + " Regular Work: " + result.regularHours
                        + "<br> OverTime: " + result.totalOvertime + " Straight: " + result.straightHours + " Premium: " + result.premiumHours
                        + "<br><b> TotalHours: " + result.totalHours + "</b>");
                },
                error: function (msg) {
                    DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
                }
            });
        });

    }
    
    export function isValidDateFormat(dateString) {
        const reg = /^20\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/;
        return reg.test(dateString);
    }

    function getDayNumberFromDataField(dataField): number {
        const match = /^day_(\d+)$/.exec(dataField);

        if (match != null) {
            return parseInt(match[1]);
        }

        return null;
    }

    export function customizeColumns(columns) {
        var headerTemplate = function (header, info) {
            $("<div>").html(info.column.caption).appendTo(header);
        };

        const grid = $("#TimeSheetEntryGrid").dxDataGrid("instance");
        const startDate = moment(grid.option("startDate"));

        for (var i = 0; i < columns.length; i++)
        {
            const dataField = columns[i].dataField;
            const day = getDayNumberFromDataField(dataField);

            if (day != null) {
                const date = moment(startDate).add(day, "day");

                columns[i].caption = date.format("DD") + "<br />" + date.format("dd")[0];
                columns[i].alignment = "right";
                columns[i].headerCellTemplate = headerTemplate;
            }
        }
    }

    export function customizeHoursSummary(data) {
        if (data.value > 0) {
            return data.value;
        }
    }

    export function contentReady(e) {
        if (!e.component.__summaryIsNotAdded) {
            const items = e.component.option("summary.totalItems");
            const totalDayColumns = 14;

            for (var i=0; i < totalDayColumns; i++) {
                const columnName = "day_" + i;

                items.push({
                    column: columnName,
                    summaryType: "sum",
                    cssClass: "",
                    customizeText: customizeHoursSummary
               });
            }
           
            e.component.option("summary.totalItems", items);
            e.component.__summaryIsNotAdded = true;
        }

   }

    export function rowPrepared(e) {
        if (e.rowType == "totalFooter") {
            e.rowElement[0].class = "";
            e.rowElement[0].style.backgroundColor = "#5aca5e";
        }
    }

    export function cellPrepared(e) {
        if (e.rowType == "data") {
            const dataField = e.column.dataField;
            const day = getDayNumberFromDataField(dataField);
            const row = e.row;

            var weekIsReadOnly = false;

            if (day <= 6 && row.data["week_1_Locked"] === true) {
                weekIsReadOnly = true;
            } else if (day > 6 && (row.data["week_2_Locked"] === true)) {
                weekIsReadOnly = true;
            }

            if (day != null && day > 0) {
                const columnName = "day_" + day + "_R";
                const disabled = row.data[columnName] || weekIsReadOnly;
                const cellClass = disabled ? "readonly-timeentry" : "";

                e.cellElement.addClass(cellClass);
            }
        }
    }

    export function editCellTemplate($cellElement, cellInfo) {
        const dataField = cellInfo.column.dataField;
        const day = getDayNumberFromDataField(dataField);

        var weekIsReadOnly = false;

        if (day <= 6 && cellInfo.row.data["week_1_Locked"] === true) {
            weekIsReadOnly = true;
        } else if (day > 6 && (cellInfo.row.data["week_2_Locked"] === true)) {
            weekIsReadOnly = true;
        }

        if (day != null) {
            const columnName = "day_" + day + "_R";
            const disabled = cellInfo.row.data[columnName] || weekIsReadOnly;
            const div = document.createElement("div");
            const dataGrid = cellInfo.component;

            $cellElement.append(div);

            var buttons = [];

            if (!weekIsReadOnly) {
                var options = {
                    icon: "edit",
                    onClick(e) {
                        showTimeEntryDialog(cellInfo.row.key, day);
                    }
                };

                buttons = [{ 
                    location: "after",
                    name: "edit",
                    options: options }];
            };

           
            $(div).dxNumberBox({
                value: cellInfo.value,
                buttons: buttons,
                step: 0,  
                onKeyDown: function (e:any) {  
                    if (e.event.keyCode === 38 /* down arrow */ || e.event.keyCode === 40 /* up arrow */)  
                        e.event.stopPropagation();  
                }, 
                onValueChanged(e) {
                    cellInfo.setValue(e.value);

                    if (e.value === null || e.value === 0) {
                        gridOperation = GridOperation.Delete;
                    } else if (e.previousValue !== null && e.value !== null) {
                        gridOperation = GridOperation.Update;
                    } else {
                        gridOperation = GridOperation.Insert;
                    }

                    dataGrid.saveEditData();
                }
            });

            const inputElement = $cellElement.find(".dx-texteditor-input-container").find("input");
            if (inputElement != null && disabled) {
                inputElement.attr("disabled", "disabled");
                inputElement.attr("readonly", "readonly");
                inputElement.attr("style", "color: lightgray;")
            }
        }
    }

    export function showTimeEntryDialog(key: any, day: number) {
        const grid = $("#TimeSheetEntryGrid").dxDataGrid("instance");
        const startDate = moment(grid.option("startDate"));
        const usageDate = moment(startDate).add(day, "day"); 
        const parameters = { 
            key: key,
            usageDate: usageDate };

        const timeEntryDialog =
            new Areas.Dialogs.TimeEntry.TimeEntryDialog(
                dialogClosing, parameters);
   }

     function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        Areas.refreshGrid("TimeSheetEntryGrid");
        UpdateTotals();
    }

    export function beforeSend(operation, ajaxSettings) {
        const grid = $("#TimeSheetEntryGrid").dxDataGrid("instance");
        const startDate = moment(grid.option("startDate"));

        if (operation === "insert" || operation === "update") {
            let values = JSON.parse(ajaxSettings.data.values);

            const dayNumberFromJsonString = /day_(\d+)/.exec(ajaxSettings.data.values);
            if (dayNumberFromJsonString != null) {
                const day = parseInt(dayNumberFromJsonString[1]);
                const dayFieldName = dayNumberFromJsonString[0];

                values.usageDate = moment(startDate).add(day, "day").format("YYYY-MM-DD");
                values.usageAmount = values[dayFieldName] === null ? 0 : values[dayFieldName];
            }

            switch (gridOperation) {
                case GridOperation.Insert:
                    ajaxSettings.url = "/TimeEntry/TimeEntry/Post";
                    ajaxSettings.method = "POST"; 
                    const key = JSON.parse(ajaxSettings.data.key);
                    values = {...key, ...values }; // This merges the properties from both Json objects
                    break;

                case GridOperation.Update:
                    ajaxSettings.url = "/TimeEntry/TimeEntry/Put";
                    ajaxSettings.method = "PUT"; 
                    break;

                case GridOperation.Delete:
                    ajaxSettings.url = "/TimeEntry/TimeEntry/Delete";
                    ajaxSettings.method = "DELETE"; 
                    break;

                default:
                    ajaxSettings.url = "";
                    ajaxSettings.method = "";
                    break;
            }

            gridOperation = GridOperation.None;

            ajaxSettings.data.values = JSON.stringify(values);
        }
    }

    export function rowUpdated() {
        UpdateTotals();
    }
}
